import React, { useState } from 'react';
import { Camera, Search, Scan } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Loyalty.css';

// ---------------- COMPONENT ----------------
const LoyaltyQr: React.FC = () => {
  const navigate = useNavigate();

    const apiAddress = process.env.REACT_APP_SECRET;
  const [userName, setUserName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // ---------------- FETCH CUSTOMER DATA BY USERNAME ----------------
  const fetchCustomerData = async (userName: string) => {
    setLoading(true);
    setError(null);

    try {
 
      const url = `${apiAddress}/api/SubSection/GetUserInfoById/${userName}`;
      
      console.log('Fetching from:', url);
      
      const res = await fetch(url);
      
      console.log('Response status:', res.status);
      
      if (!res.ok) {
        const text = await res.text();
        console.error('Error response:', text);
        throw new Error(`Customer not found (Status: ${res.status})`);
      }

      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await res.text();
        console.error('Non-JSON response:', text);
        throw new Error('Server returned invalid response format');
      }

      const data = await res.json();
      console.log('Customer data:', data);
      
      // 🔥 SUCCESS → NAVIGATE with id in URL and all data as state
 // Navigate with userId parameter
navigate(`/loyalty-restaurant-view/${data.id}`, {
  state: {
    id: data.id,
    firstName: data.firstName,
    lastName: data.lastName,
    userName: data.userName
  }
});
      
    } catch (err) {
      console.error('Fetch error:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch customer data');
    } finally {
      setLoading(false);
    }
  };

  // ---------------- LOOKUP ----------------
  const handleLookup = () => {
    if (!userName.trim()) return;
    fetchCustomerData(userName.trim());
  };

  // ---------------- SIMULATE SCAN ----------------
  const handleSimulateScan = () => {
    // Use demo username for simulation
    const demoUserName = '8913fe3e-f51b-461a-8429-9f7684f660b4';
    setUserName(demoUserName);
    fetchCustomerData(demoUserName);
  };

  // ---------------- UI ----------------
  return (
    <div className="container">
      <div className="scannerBox">
        <div className="scanIcon">
          <Scan size={64} strokeWidth={1.5} />
        </div>

        <h2 className="scanTitle">Scan Customer QR Code</h2>
        <p className="scanDescription">
          Scan a customer's loyalty QR code or enter their username manually to view their points and process redemptions.
        </p>

        <div className="inputGroup">
          <input
            type="text"
            className="input"
            placeholder="Enter Username"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleLookup()}
            disabled={loading}
          />

          <button
            className="lookupBtn"
            style={{ opacity: userName.trim() && !loading ? 1 : 0.6 }}
            onClick={handleLookup}
            disabled={!userName.trim() || loading}
          >
            <Search size={16} style={{ marginRight: 8 }} />
            {loading ? 'Loading...' : 'Look Up'}
          </button>
        </div>

        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
};

export default LoyaltyQr;